import {Component} from 'react';
import withRouterCompat from '../../objects/CommonUse/with_router_compat';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};


class LogoutForm extends Component {
    constructor(props) {
        super(props);
        this.state = {username: "", 
            password: "",

            };
    }
 
    onNavigate = (path) => {
        const { navigate, location } = this.props;
        // Corrected pathname comparison
        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };
    
    render() { 
       
        return <>
            <form className="login-form px-2 pb-2" id="loginForm" onSubmit={()=>this.handleSubmit()}>
                <h6 className="mt-2">Logged in as {this.props.username}</h6>
                <div className="form-group my-0 text-right">
                    <button type="submit" className="btn btn-primary">Log out</button>
                </div>
            </form>
            </>
    }

    handleSubmit()
    { 
        this.props.onLogout();
        this.onNavigate("");
    }
}

export default connect(mapStateToProps, mapDispatchToProps) (withRouterCompat(LogoutForm));